export const commonData = {
	data() {
		return {
			ossUrl:'https://oss.ipiip.cn',
			height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
		}
	},
}

